import axios from '@fs/zion-axios'

const BASE_RFT_PATH = '/service/dmc/rft'

export function getFunctionList() {
  return axios.get(`${BASE_RFT_PATH}/options`)
}

export function submitQuery(queryType, queryParams) {
  return axios.post(`${BASE_RFT_PATH}/${queryType}`, {
    ...queryParams,
  })
}

export function getQueriesList(pageNumber, resultsNumber, showAll, oldestToNewest) {
  return axios.get(
    `${BASE_RFT_PATH}/list?page=${pageNumber}&results=${resultsNumber}&showMine=${!showAll}&oldestToNewest=${oldestToNewest}`
  )
}

export function viewResults(jobId) {
  return axios.get(`${BASE_RFT_PATH}/preview/${jobId}`)
}

export function checkStatus(jobId) {
  return axios.get(`${BASE_RFT_PATH}/${jobId}`)
}

export function deleteResults(jobId) {
  return axios.delete(`${BASE_RFT_PATH}/${jobId}`)
}
